import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AutotextService } from 'src/app/autotext.service';
import { ExamsService } from 'src/app/exams.service';
import { CardioService } from '../cardio.service';

@Component({
    selector: 'app-cardio-findings',
    templateUrl: './cardio-findings.component.html',
    styleUrls: ['./cardio-findings.component.scss'],
    standalone: false
})
export class CardioFindingsComponent implements OnInit, OnDestroy {
  FindingsForm: UntypedFormGroup;
  sub = new Subscription()
  groups = [ 'Response','Arythmia','Conduction','ST','EndReason','ECG'];
  findings = ['CCA', 'Bulb', 'ICAProx', 'MidICA', 'ECA', 'VA','IMT'];
  DurationMinutes: any;
  DurationSeconds: any;

  constructor(private fb:UntypedFormBuilder, public es: ExamsService,public atS:AutotextService, public cardioS:CardioService) { 
    this.FindingsForm = this.fb.group({
      Duration: [''],
      Stage:[''],
      METs:[''],
      HeartRate:[''],
      MaxExpectedHeartRate:[''],
      MaxHeartRate:[''],
      Precentage:[''],
      bpSystolicRest:[''],
      bpDiastolicRest:[''],
      bpSystolic:[''],
      bpDiastolic:[''],
      Response:[''],
      Arythmia:[''],
      Conduction:[''],
      ST:[''],
      EndReason:[''],
      PulseRate:[''],
      PulseStatus:[''],
      Medication:[''],
      Protocol:[''],
      OtherStaff:[''],
      ECG:['']
    });
  }

  ngOnInit() {
    this.es.fillForm(this.FindingsForm,"cardioFindings",false,true);
    this.sub = this.es.formLoaded$.subscribe(() => {
      var age = this.es.patServ.getPat().getAge().split(" ")[0];
      this.FindingsForm.get('MaxExpectedHeartRate').setValue(220- (Number(age)));
      if(! this.FindingsForm.get('Protocol').value)
        this.FindingsForm.get('Protocol').setValue('Bruce', {emitEvent: false})
      this.sub = this.FindingsForm.get('MaxHeartRate').valueChanges.subscribe((data) => {
        var prec = null;
        if(data && +this.FindingsForm.get('MaxExpectedHeartRate').value){
          var MHR = data;
          var EMHR = +this.FindingsForm.get('MaxExpectedHeartRate').value
          prec = (MHR / EMHR) *100;
          prec = prec.toString().split('.')[0];
        }
        if(prec == Infinity){
          prec = null;
        }
        this.FindingsForm.get('Precentage').patchValue(prec);
      })

      const durationParts = this.FindingsForm.get("Duration").value;
      const convertedDuration = String(durationParts).split(".");

      if (convertedDuration.length > 1) {
        this.DurationMinutes = convertedDuration[0];
        this.DurationSeconds = convertedDuration[1];
      } else {
        this.DurationMinutes = this.FindingsForm.get("Duration").value;
        this.DurationSeconds = "";
      }
    });

    
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  updateDuration() {
    const durationSeconds = Number(this.DurationSeconds) || 0;
    const durationMinutes = Number(this.DurationMinutes) || 0;

    const combinedDuration = `${durationMinutes}.${durationSeconds}`;
    this.FindingsForm.get("Duration").setValue(combinedDuration);
  }

  limitSeconds() {
    const maxDuration = 59;
    const value = Number(this.DurationSeconds);
    if (isNaN(value) || value > maxDuration) {
      this.DurationSeconds = maxDuration;
    }
  }
}
